module.exports = __webpack_public_path__ + "img/logo-feelgood-plus.653dff9a.svg";